import "@arco-design/web-react/es/DatePicker/style";
import _DatePicker from "@arco-design/web-react/es/DatePicker";
import React from 'react';
const {
  RangePicker
} = _DatePicker;
export function SelectDate({
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement(RangePicker, {
    style: {
      width: '100%'
    },
    value: value,
    showTime: {
      defaultValue: ['00:00', '24:00'],
      format: 'HH:mm'
    } // format="YYYY-MM-DD"
    ,
    onChange: onChange
  });
}